import {
  ArrowLeftRight, Atom, BellRing, BookOpenCheck, BrainCircuit, BriefcaseBusiness, Building2,
  Calculator, CheckCircle2, ChevronRight, CircleGauge, Cloud, ContactRound, Database, FileKey2,
  FileScan, Files, GitCompareArrows, Home, Landmark, LayoutDashboard, Lightbulb, Menu, Network,
  Orbit, PanelLeftClose, PanelLeftOpen, Plus, Route, ScanSearch, Search, Settings, ShieldCheck,
  Sparkles, Target, UploadCloud, UsersRound, Wifi, WifiOff, X, type LucideProps
} from 'lucide-react';

const icons = {
  ArrowLeftRight, Atom, BellRing, BookOpenCheck, BrainCircuit, BriefcaseBusiness, Building2,
  Calculator, CheckCircle2, ChevronRight, CircleGauge, Cloud, ContactRound, Database, FileKey2,
  FileScan, Files, GitCompareArrows, Home, Landmark, LayoutDashboard, Lightbulb, Menu, Network,
  Orbit, PanelLeftClose, PanelLeftOpen, Plus, Route, ScanSearch, Search, Settings, ShieldCheck,
  Sparkles, Target, UploadCloud, UsersRound, Wifi, WifiOff, X
};

export function Icon({ name, ...props }: { name: string } & LucideProps) {
  const Component = icons[name as keyof typeof icons] || Sparkles;
  return <Component {...props} />;
}
